/**
 * Product Model - Processes API responses for product data
 */

/**
 * Process product list response data
 * @param {Object} response - API response from product list endpoint
 * @returns {Object} Formatted product list data
 */
export const productListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch store list',
        data: []
    };
};

/**
 * Process merge product response
 * @param {Object} response - API response from product merge endpoint
 * @returns {Object} Formatted merge response
 */
export const mergeProductPost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Product merged successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to merge product'
    };
};

/**
 * Process reject product response
 * @param {Object} response - API response from product reject endpoint
 * @returns {Object} Formatted reject response
 */
export const rejectProductPost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Product rejected successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to reject product'
    };
};
export const mapBillToList = (response) => {
  if (response && response.data && response.data.success === true) {
    const data = Array.isArray(response.data.data) ? response.data.data : []
    // Normalize to { slack, label }
    const normalized = data.map((item) => ({
      slack:
        item.slack ||
        item.id ||
        item.customer_slack ||
        item.supplier_slack ||
        item.code ||
        item.value ||
        '',
      label:
        item.label ||
        item.name ||
        item.customer_name ||
        item.supplier_name ||
        item.title ||
        item.display ||
        '',
        id:  item.id || ''
    }))
    return { success: true, data: normalized }
  }
  return { success: false, data: [] }
}